<template>
  <div class="sub_menu_01">
    <div class="snb">
      <ul v-if="isOrgUser || isOrgAdmin">
        <li
          :class="{
            active:
              $route.name == USER_ROUTES.Mypage.Order.Org.Request.Name ||
              $route.name == USER_ROUTES.Mypage.Order.Org.RequestList.Name,
          }"
        >
          <router-link
            :to="{ name: USER_ROUTES.Mypage.Order.Org.RequestList.Name }"
            >진단신청</router-link
          >
        </li>
        <li
          :class="{ active: $route.name == USER_ROUTES.Mypage.Order.Org.Name }"
        >
          <router-link :to="{ name: USER_ROUTES.Mypage.Order.Org.Name }"
            >진단검사 관리</router-link
          >
        </li>
        <li
          :class="{
            active:
              $route.name == USER_ROUTES.Mypage.Order.Org.PurchaseList.Name,
          }"
        >
          <router-link
            :to="{ name: USER_ROUTES.Mypage.Order.Org.PurchaseList.Name }"
            >견적(발주) 목록</router-link
          >
        </li>
        <li
          :class="{ active: $route.name == USER_ROUTES.Mypage.User.Org.Path }"
        >
          <router-link :to="{ name: USER_ROUTES.Mypage.User.Org.Name }"
            >사용자 관리</router-link
          >
        </li>
      </ul>
      <ul v-else>
        <li
          :class="{
            active: $route.name == USER_ROUTES.Mypage.Order.Personal.Path,
          }"
        >
          <router-link :to="{ name: USER_ROUTES.Mypage.Order.Personal.Name }"
            >진단검사</router-link
          >
        </li>
        <li :class="{ active: $route.name == USER_ROUTES.Mypage.Modify.Path }">
          <router-link :to="{ name: USER_ROUTES.Mypage.Modify.Name }"
            >회원정보수정</router-link
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useAuth } from "@/composables/useAuth";
const { isOrgUser, isOrgAdmin } = useAuth();
</script>

<style>
.sub_scroll_wrap {
  overflow: hidden;
  height: 39px;
  border-bottom: 1px solid #ccc;
  background: #fff;
}
.sub_scroll_wrap > div {
  position: relative; /*padding: 0 30px;*/
}
.sub_scroll_wrap > div > div {
  overflow-x: scroll;
}
.sub_scroll_wrap > div > div .scroll_nav {
  display: inline-block;
  min-width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
  font-size: 0;
  text-align: center;
  white-space: nowrap;
}
.sub_scroll_wrap > div > div .scroll_nav li {
  display: inline-block;
}
.sub_scroll_wrap > div > div .scroll_nav li a {
  display: inline-block;
  height: 39px;
  line-height: 39px;
  padding: 0 12px;
  font-size: 13px;
  color: #bbb;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  box-sizing: border-box;
  font-weight: 600;
}
.sub_scroll_wrap > div > div .scroll_nav li.on a {
  color: #be7b42;
  font-weight: 600;
}
.sub_scroll_wrap > div i {
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 39px;
}
.sub_scroll_wrap > div i.prev:before {
  content: "";
  position: absolute;
  top: 0;
  left: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-right-color: #333;
}
.sub_scroll_wrap > div i.next {
  right: 0;
  left: inherit;
}
.sub_scroll_wrap > div i.next:before {
  content: "";
  position: absolute;
  top: 0;
  right: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-left-color: #333;
}
@media screen and (min-width: 768px) {
  .sub_scroll_wrap > div i {
    display: none;
  }
}
@media screen and (min-width: 1200px) {
  .sub_scroll_wrap {
    overflow: visible;
    height: auto;
    border-bottom: none;
    background: #fff;
    box-shadow: 3px 3px 3px rgb(0 0 0 / 10%);
  }
  .sub_scroll_wrap > div {
    position: relative;
    padding: 0;
  }
  .sub_scroll_wrap > div > div {
    overflow: hidden;
  }
  .sub_scroll_wrap > div > div .scroll_nav {
    display: table;
    margin: 0;
    width: 100%;
    padding: 0;
    white-space: normal;
    text-align: left;
    border-collapse: collapse;
  }
  .sub_scroll_wrap > div > div .scroll_nav li {
    display: table-cell;
    width: 33%;
    position: relative;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    background: #bbb;
    width: 1px;
    height: 15px;
    margin-top: -7px;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:last-child:after {
    display: none;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:before {
    position: absolute;
    visibility: hidden;
    left: 0;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 3px;
    background: #be7b42;
    content: "";
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: all 0.2s ease-in-out 0s;
    transition: all 0.2s ease-in-out 0s;
    opacity: 0.85;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 60px;
    line-height: 60px;
    padding: 0 5px;
    font-size: 16px;
    text-align: center;
    color: #bbbbbb;
    font-weight: 600;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a:hover {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on a {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on:before,
  .sub_scroll_wrap > div > div .scroll_nav li:hover:before {
    visibility: visible;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}
</style>
